import {
    UserInteractionAction,
    UserInteractionActionTypes,
    UserInteractions
} from "../interfaces/context/searchContextInterfaces";

export const userInteractionsReducer = (state: UserInteractions, action: UserInteractionAction) => {
    switch (action.type) {
    case UserInteractionActionTypes.updateJobTileViews: {
        const updatedState = {
            ...state,
            tilesViewedJobIds: [...state.tilesViewedJobIds, ...action.payload.tilesViewedJobIds]
        };
        return updatedState;
    }
    case UserInteractionActionTypes.resetJobTileViews: {
        const updatedState = {
            ...state,
            tilesViewedJobIds: []
        };
        return updatedState;
    }
    case UserInteractionActionTypes.updateFilterInteraction: {
        const updatedState = {
            ...state,
            ...action.payload
        };
        return updatedState;
    }
    default: {
        return state;
    }
    }
};
